"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.exerciseOptionsRequestSchema = exports.AuthorisingOfficerSchema = exports.createOptionGrantRequestSchema = exports.OptionGrantsDeleteSchema = exports.OptionGrantsPatchSchema = exports.OptionGrantValidationSchema = exports.IntervalValidationSchema = exports.PeriodValidationSchema = exports.maxNumberLength = exports.roundTo = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const date_fns_1 = require("date-fns");
const yup = __importStar(require("yup"));
const yup_1 = require("yup");
const constants_1 = require("../constants");
const enums_1 = require("../contracts/enums");
const IndividualShareholder_1 = require("./IndividualShareholder");
const requiredMessage = (field) => `${field} is a required field`;
const positiveMessage = (field) => `${field} must be a positive number`;
const integerMessage = (field) => `${field} must be an integer`;
const roundTo = (rounder) => (n) => +`${Math.round(+`${n}e+${rounder}`)}e-${rounder}`;
exports.roundTo = roundTo;
const maxNumberLength = (n) => +"9".repeat(n);
exports.maxNumberLength = maxNumberLength;
const PeriodValidationSchema = (fieldName) => (0, yup_1.object)({
    period: (0, yup_1.number)()
        // eslint-disable-next-line no-restricted-globals
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0, positiveMessage(`${fieldName} period`))
        .max(99)
        .integer(integerMessage(`${fieldName} period`))
        .required(requiredMessage(`${fieldName} period`)),
    timeUnit: (0, yup_1.string)()
        .oneOf(Object.values(enums_1.TimeUnit), `${fieldName} must be one of the following values: Months, Years`)
        .required(requiredMessage(`${fieldName} period time unit`)),
});
exports.PeriodValidationSchema = PeriodValidationSchema;
const IntervalValidationSchema = (fieldName) => (0, yup_1.object)({
    interval: (0, yup_1.number)()
        // eslint-disable-next-line no-restricted-globals
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0, positiveMessage(`${fieldName} interval`))
        .max(99)
        .integer(integerMessage(`${fieldName} interval`))
        .required(requiredMessage(`${fieldName} interval`)),
    timeUnit: (0, yup_1.string)()
        .required()
        .oneOf(Object.values(enums_1.TimeUnit), `${fieldName} must be one of the following values: Months, Years`),
});
exports.IntervalValidationSchema = IntervalValidationSchema;
exports.OptionGrantValidationSchema = (0, yup_1.object)({
    optionPoolId: (0, yup_1.string)().label("Option pool id").required(),
    numberOfOptions: (0, yup_1.number)()
        // eslint-disable-next-line no-restricted-globals
        .transform((value) => (isNaN(value) ? undefined : value))
        .label("Number of options")
        .required()
        .integer()
        .min(0)
        .lessThan((0, exports.maxNumberLength)(15)),
    exercisePrice: (0, yup_1.number)()
        // eslint-disable-next-line no-restricted-globals
        .transform((value) => (isNaN(value) ? undefined : value))
        .label("Exercise price")
        .required()
        .min(0)
        .lessThan((0, exports.maxNumberLength)(12)),
    lastExerciseDate: (0, yup_1.string)()
        .label("Exercise exercise date")
        .required(constants_1.DATE_VALID)
        .typeError(constants_1.DATE_VALID)
        .test("lastExerciseDate", constants_1.DATE_VALID, (lastExerciseDate) => (0, date_fns_1.isValid)(new Date(lastExerciseDate)) && (0, mystake_common_sdk_1.getDateYear)(lastExerciseDate) > 1920)
        .when("dateOfGrant", ([dateOfGrant], schema) => dateOfGrant === null
        ? schema.test("lastExerciseDate when grantDate not set", `Last exercise date field must be later than ${(0, date_fns_1.addDays)(new Date(), -1).toDateString()}`, (lastExerciseDate) => (0, date_fns_1.isAfter)(new Date(lastExerciseDate), (0, date_fns_1.addDays)(new Date(), -1)))
        : schema.test("lastExerciseDate when grantDate exists", `Last exercise date field must be later than ${(0, date_fns_1.addDays)(new Date(dateOfGrant), -1).toDateString()}`, (lastExerciseDate) => (0, date_fns_1.isAfter)(new Date(lastExerciseDate), (0, date_fns_1.addDays)(new Date(dateOfGrant), -1)))),
    vestingType: (0, yup_1.string)().label("Vesting type").required().oneOf(Object.values(enums_1.OptionGrantsVestingType)),
    vestingPeriod: yup.mixed().when("vestingType", {
        is: enums_1.OptionGrantsVestingType.TIME,
        then: () => (0, exports.PeriodValidationSchema)("Vesting"),
        otherwise: (schema) => schema.strip(),
    }),
    vestingInterval: yup.mixed().when("vestingType", {
        is: enums_1.OptionGrantsVestingType.TIME,
        then: () => (0, exports.IntervalValidationSchema)("Vesting"),
        otherwise: (schema) => schema.strip(),
    }),
    cliff: yup.mixed().when("vestingType", {
        is: enums_1.OptionGrantsVestingType.TIME,
        then: () => (0, yup_1.object)({
            cliffPeriod: (0, exports.PeriodValidationSchema)("Cliff"),
            atCliff: (0, yup_1.number)()
                // eslint-disable-next-line no-restricted-globals
                .transform((value) => (isNaN(value) ? undefined : value))
                .label("Vest at cliff")
                .min(0.01)
                .max(100)
                .required(),
        }).optional(),
        otherwise: (schema) => schema.strip(),
    }),
    dateOfGrant: (0, yup_1.string)()
        .label("Date of grant")
        .required(constants_1.DATE_VALID)
        .typeError(constants_1.DATE_VALID)
        .test("dateOfGrant", constants_1.DATE_VALID, (dateOfGrant) => (0, date_fns_1.isValid)(new Date(dateOfGrant)) && (0, mystake_common_sdk_1.getDateYear)(dateOfGrant) > 1920)
        .test("Date-in-future", "Date of grant cannot be more than 1 year in future", (dateOfGrant) => new Date(dateOfGrant).getTime() <= (0, date_fns_1.addYears)(new Date(), 1).getTime()),
});
exports.OptionGrantsPatchSchema = (0, yup_1.object)({
    id: (0, yup_1.string)(),
});
exports.OptionGrantsDeleteSchema = (0, yup_1.object)({
    id: (0, yup_1.string)(),
});
const investorValidationSchema = (0, yup_1.object)({
    entityType: (0, yup_1.string)().oneOf(Object.values(enums_1.EntityType)),
    trusteeType: (0, yup_1.string)().oneOf([...Object.values(enums_1.TrusteeType), undefined]),
    investor: IndividualShareholder_1.ShareholderSchema,
});
exports.createOptionGrantRequestSchema = (0, yup_1.object)({
    optionholder: investorValidationSchema,
    optionGrant: exports.OptionGrantValidationSchema,
});
exports.AuthorisingOfficerSchema = yup.object().required("Please select authorising officer");
const IOptionExerciseTransactionSchema = (0, yup_1.object)().shape({
    quantity: (0, yup_1.number)()
        .typeError(constants_1.NUMBER_MUST_BE_POSITIVE)
        .integer(constants_1.NUMBER_MUST_BE_POSITIVE)
        .positive(constants_1.NUMBER_MUST_BE_POSITIVE),
    exercisePrice: (0, yup_1.number)().typeError(constants_1.NUMBER_MUST_BE_POSITIVE).min(0),
    exerciseDate: (0, yup_1.string)().typeError(constants_1.DATE_VALID).required(constants_1.DATE_REQUIRED),
    totalAmountPaid: (0, yup_1.number)(),
    authorisingOfficer: exports.AuthorisingOfficerSchema,
});
exports.exerciseOptionsRequestSchema = (0, yup_1.object)({
    exerciseData: IOptionExerciseTransactionSchema,
});
//# sourceMappingURL=OptionGrant.js.map